import gql from 'graphql-tag';

import type { DocumentVariationDetails } from 'src/data/document';
import { executeGqlQuery } from 'src/graphql/client';
import { FRAGMENT_DOCUMENT_VARIATION_DETAILS } from 'src/graphql/sharing/schema';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';
import type { BackendQueryProjectVariationDetailsArgs } from 'src/types/backend';

const QUERY = gql`
  query ProjectVariationDetails($projectId: ID!, $assetGroupId: ID, $assetId: ID!, $text: String!) {
    projectVariationDetails(
      projectId: $projectId
      assetGroupId: $assetGroupId
      assetId: $assetId
      text: $text
    ) {
      ...DocumentVariationDetails
    }
  }
  ${FRAGMENT_DOCUMENT_VARIATION_DETAILS}
`;

type Variables = BackendQueryProjectVariationDetailsArgs;

/** The insights of a saved item of a project shared for review, short-form or long-form. */
export const queryProjectVariationDetails = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  throwIfResultHasErrors(result);

  return getSingleProp<DocumentVariationDetails>(result.data);
};
